import {Button} from 'antd'
import openWindow from '@/script/openWindow.mjs'
import {useFilterByLicense} from '@/biz/license.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default function PropertiesPaneButtonPreview(props) {
    const filterByLicense = useFilterByLicense()
    const map = useMapContext()

    const handleClick = e => {
        const {prjId, sVer} = map.data
        const target = e.altKey ? '_self' : '_blank'
        openWindow('/FormilyPreview', {prjId, sVer}, target)
    }

    return filterByLicense('M00030002',
        <Button
            onClick={handleClick}
            {...props}
        >
            界面看板
        </Button>
    )
}
